export default [
  {
    title: 'مدیریت گردونه شانس',
    icon: 'GiftIcon',
    children: [
      {
        title: 'گردونه های شانس',
        route: { name: 'prizeWheels' },
        resource: 'PrizeWheelManager',
        action: 'show',
      },
      {
        title: 'برندگان گردونه شانس',
        route: { name: 'prizeWheelUsers' },
        resource: 'PrizeWheelManager',
        action: 'show',
      }
    ]
  }
]